// extracted by mini-css-extract-plugin
export default {"action":"NSAbBwvrggT39V3VJzXp","text":"JlSnGq2Xmvn9Grwy8RE8"};